<h2>Back-end Users</h2>

<mat-spinner *ngIf="initializing"></mat-spinner>

<div class="button_row" *ngIf="!initializing">
    <button mat-raised-button
            routerLink="/">Back</button>

    <button mat-raised-button
            color="primary"
            routerLink="/backend-user">+ New User</button>
</div>

<div id="table_area">
    <div *ngIf="visibleUsers?.length && !initializing" class="paginator_row">
        <span>
            <mat-form-field>
                <mat-label>Filter</mat-label>
                <input matInput [(ngModel)]="filter" (keyup)="applyFilter($event)">
            </mat-form-field>
            <button mat-icon-button
                    [ngClass]="{hidden: !filter}"
                    color="accent"
                    matTooltip="Clear filter"
                    (click)="clearFilter()">
                <mat-icon>highlight_off</mat-icon>
            </button>
        </span>
        <mat-checkbox [(ngModel)]="showDisabled"
                      (ngModelChange)="disabledChanged()">Show disabled users</mat-checkbox>
        <mat-paginator #paginator
                       [hidden]="initializing"
                       [length]="visibleUsers.length"
                       [pageIndex]="INITIAL_PAGE_INDEX"
                       [pageSize]="INITIAL_PAGE_SIZE"
                       [pageSizeOptions]="[5, 10, 20]"
                       (page)="pageChanged($event)"></mat-paginator>
    </div>
    <table mat-table *ngIf="visibleUsers?.length && !initializing"
           [dataSource]="dataSource">

        <ng-container matColumnDef="email">
            <th mat-header-cell *matHeaderCellDef>Email</th>
            <td mat-cell *matCellDef="let user" [innerHTML]="user.email"></td>
        </ng-container>

        <ng-container matColumnDef="type">
            <th mat-header-cell *matHeaderCellDef>Type</th>
            <td mat-cell class="centered" *matCellDef="let user" [innerHTML]="user.type"></td>
        </ng-container>

        <ng-container matColumnDef="created">
            <th mat-header-cell *matHeaderCellDef>Created</th>
            <td mat-cell class="centered" *matCellDef="let user" [innerHTML]="user.created | date:'short'"></td>
        </ng-container>

        <ng-container matColumnDef="updated">
            <th mat-header-cell *matHeaderCellDef>Updated</th>
            <td mat-cell class="centered" *matCellDef="let user" [innerHTML]="user.updated | date:'short'"></td>
        </ng-container>

        <tr mat-header-row *matHeaderRowDef="columnsToDisplay"></tr>
        <tr mat-row [ngClass]="{disabled: user.disabled}"
            (click)="showUser(user)"
            *matRowDef="let user; columns: columnsToDisplay"></tr>

    </table>
</div>
